/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col,
} from "reactstrap";

function AboutProject() {

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });
  return (
    <>
      <div className="section section-dark profile-content">
        <Container>
          <div className="owner">
            <div className="avatar">
              <img
                alt="Daniloabella"
                className="img-circle img-no-padding img-responsive"
                src={require("assets/img/SpecialThanks/Avatar_YouTube-Naranja.jpg")}
              />
            </div>
            <div className="name">
              <h4 className="title">
                Daniloabella <br />
              </h4>
              <h6 className="description"> Computer Scientist | MKDOTE author </h6>
            </div>
          </div>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="6">
              <p>
                <br />
                My dream is to create an extremely epic and exciting game, and with the excellent work of the MK Mugen community and the Borg117 engine,
                I saw an opportunity to make my mark with this game, remembering what MK was like in its early titles.
              </p>
              <br />
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="6">
              <p>
                MK Defenders of the Earth is a non-profit fan-game created by Daniloabella based on the classic games of the MK saga.
                <br /><br />
                Powered on Mugen, this game uses Borg117's Season 2 FINAL (PATCH 4) as the base and material of the MKP 4.1 by MKP Team.
                <br /><br />
                The original chars from Season 2 Final were used as a base (except for Frost) to develop new chars with a new graphic appearance, which received several alterations to be added to this game.
                <br /><br />
                Stages already created by the mugen community were altered to be mounted in this game, original scenarios were also created using fan-arts, free green screen animations and sprites from other scenarios.
                <br /><br />
                The soundtrack is a set of royalty-free music with their respective respected licenses or permissions granted.
                <br /><br />
                All attribution to the material used in this game is available in its credits. For some songs, the link to their license was added.
                <br /><br />
                For any questions please send an email to daniloabella@gmail.com.
                <br /><br />
              </p>
              <br />
            </Col>
          </Row>
          <br />
        </Container>
      </div>
    </>
  );
}

export default AboutProject;
